<div class="ec-economics-aggregated-container" fxLayout="column" fxLayoutGap="30px"
     *appVar="hierarchyEntityObservable|async as entity">

    <!-- FIXME change showGSEBtn to true when GSE data is handled -->
    <app-filter-bar
            [showNullData]="isEcInactiveOrFuture"
            [config]="billingPeriodCfg"
            [billingPeriod]="billingPeriod"
            [useFilter]="USE_FILTER"
            [showGSEBtn]="false"
            [isGSEDisabled]="!response || response && response.gse || futureEc || inactiveEc || currentMonth || !isUpdatable(entity)"
            (clickGseDataEventEmitter)="onClickEnterGseData()"
            (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
    </app-filter-bar>

    <ng-container *ngIf="entity && isViewable(entity); else unviewableEntity">
        <ng-container *ngIf="response; else loadingEconomics">
            <div fxLayout="column" fxLayoutGap="20px">
                <div fxFlex="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                        <div class="txt-h-18-7">{{ 'Economics data'|i18n }}</div>
                        <div fxLayout="row" class="panel-3 br-20" fxLayoutAlign="start center" fxLayoutGap="20px">
                            <div class="txt-h-18-7">{{ 'Strategy'|i18n }}:</div>
                            <div class="txt-h-16-4">
                                {{ ((this.strategy || '')|strategy|i18n) || '-' }}
                            </div>
                            <button app-primary-button
                                    (click)="onClickEditStrategy()"
                                    [disabled]="!isWholeYear || !canSetupStrategy() || !canUpdate">
                                <app-icon name="fal-pen" class="ml-12"></app-icon>
                            </button>
                        </div>
                        <app-icon icon-color-w name="fas-exclamation-triangle"
                                  *ngIf="hasError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors) && showError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors)"
                                  [title]="'Due to partial zonal price supply, we cannot show you complete economic data for this period. No action is required on your part.'|i18n">
                        </app-icon>
                        <!-- estimated data label -->
                        <div *ngIf="dataSourceInfo && dataSourceInfo.mode !== ECMode.BASE" fxLayout="row"
                             fxLayoutAlign="start center" fxLayoutGap="10px"
                             class="txt-p-14-4">
                            <app-icon icon-color-w name="fas-exclamation-triangle"
                                      *ngIf="hasError(EconomicsErrorType.MISSING_DATA, response.errors) && showError(EconomicsErrorType.MISSING_DATA, response.errors)"
                                      [title]="'We did not receive some readings from the smart meters on this period. We estimated the missing data through statistical profiles.'|i18n">
                            </app-icon>
                        </div>
                    </div>

                    <app-consolidation-info-bar *ngIf="!this.inactiveEc && !this.futureEc"
                                                [billingPeriod]=billingPeriodSubj.asObservable()
                                                [timeZone]="timeZone"
                                                [summaryResponse]=summaryResponseSubject.asObservable()>
                    </app-consolidation-info-bar>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
                    <div fxLayout="row wrap" fxLayoutAlign="space-between start" class="w-100">
                        <div fxLayout="column" fxLayoutGap="10px" fxFlex="24">
                            <div fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px">
                                <!-- Gross incentive -->
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                        <div class="txt-h-18-7">{{ 'Gross incentive'|i18n }}</div>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="grossIncentiveTooltip"></app-icon>
                                    </div>
                                    <div *ngIf="showGrossIncentive"
                                         [class]="response.gse ? 'txt-acc-24-7' : 'txt-h-24-7'">
                                        {{ grossIncentive }}
                                    </div>
                                    <div *ngIf="showEstimatedGrossIncentive" class="txt-h-24-7">
                                        {{ estimatedGrossIncentive }}
                                    </div>
                                </div>
                                <hr class="divider">
                                <!-- Premium Incentive Rate (PIR) -->
                                <div fxLayout="column">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                                            <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                            <div class="txt-h-12-4">{{ 'Premium Incentive Rate (TIP)'|i18n }}:</div>
                                            <app-icon icon-color-h name="fas-info-circle"
                                                      [title]="'TIP is the incentive premium rate, i.e., the value of the incentive payable to the shared energy, which varies depending on several parameters, including plant capacity, zonal price, and geographic area of ownership, disbursed by the GSE and defined by the MASE.'|i18n">
                                            </app-icon>
                                        </div>
                                        <div *ngIf="response.gse || !response.gse && !isDefined(response.incentivation.estimated_gross_tip)"
                                             [class]="response.gse ? 'txt-acc-16-7' : 'txt-h-16-7'">
                                            {{ showNullData ? NULL_DATA : (response.incentivation.gross_tip|niceValue: '€':2: true) }}
                                        </div>
                                        <div *ngIf="!response.gse && isDefined(response.incentivation.estimated_gross_tip)"
                                             class="txt-h-16-7">
                                            {{ showNullData ? NULL_DATA : (response.incentivation.estimated_gross_tip|niceValue: '€':2: true) }}
                                        </div>
                                    </div>
                                    <ng-container
                                            *appVar="response.incentivation.capital_grant_plants_count as cg_plants">
                                        <div *ngIf="cg_plants > 0" class="txt-acc-12-4 ml-34">
                                            <app-icon name="fal-check-circle"></app-icon>
                                            {{ 'Using capital grant on {0} {1}'|i18n:cg_plants:((cg_plants > 1 ? 'plants' : 'plant')|i18n) }}
                                        </div>
                                    </ng-container>
                                </div>
                                <!-- CACV -->
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                                        <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                        <div class="txt-h-12-4"
                                             [innerHTML]="'Contribution enhancement energy self-consumed electricity ({0}):'|i18n: CACV_STRING">
                                        </div>
                                        <app-icon *ngIf="entity.sub_type === EntitySubType.RENEWABLE_ENERGY_COMMUNITY"
                                                  icon-color-h name="fas-info-circle"
                                                  [title]="'Cacv is the contribution for the valorization of self-consumed energy defined by ARERA\'s TIAD, equal to the product between the shared energy and the transmission tariff (TRASE), defined for low-voltage utilities.' |i18n">
                                        </app-icon>
                                        <app-icon
                                                *ngIf="entity.sub_type === EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP"
                                                icon-color-h name="fas-info-circle"
                                                [title]="'Cacv is the shared energy valuation fee defined by ARERA\'s TIAD, which is equal to the sum of the product between shared energy and the transmission tariff (TRASE), the product between shared energy and the distribution tariff for utilities for other low-voltage use (BTAU), and the sum, by voltage level and over hours, of the products between shared energy by voltage level, the coefficient of avoided losses of the same voltage level, and the hourly zonal price.' |i18n">
                                        </app-icon>
                                        <app-icon *ngIf="!showNullData && missingCacvMode(response, this.strategy)"
                                                  [title]="'Configure the destination of CACV'|i18n"
                                                  class="mr-10" icon-color-w name="fas-exclamation-triangle">
                                        </app-icon>
                                    </div>
                                    <div *ngIf="response.gse || !response.gse && !isDefined(response.incentivation.estimated_gross_c_acv)"
                                         [class]="response.gse ? 'txt-acc-16-7' : 'txt-h-16-7'">
                                        {{ showNullData ? NULL_DATA : (response.incentivation.gross_c_acv|niceValue: '€':2: true) }}
                                    </div>
                                    <div *ngIf="!response.gse && isDefined(response.incentivation.estimated_gross_c_acv)"
                                         class="txt-h-16-7">
                                        {{ showNullData ? NULL_DATA : (response.incentivation.estimated_gross_c_acv|niceValue: '€':2: true) }}
                                    </div>
                                </div>
                                <!-- GSE community costs -->
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                                        <app-icon name="fal-users" class="small-icon icon-color"></app-icon>
                                        <div class="txt-h-12-4">{{ 'GSE community costs'|i18n }}:</div>
                                        <app-icon *ngIf="billingPeriod.type === TimeFilterType.THIS_YEAR"
                                                  icon-color-h name="fas-info-circle"
                                                  [title]="'This amount is calculated over a period up to the present.'|i18n">
                                        </app-icon>
                                        <app-icon *ngIf="billingPeriod.type !== TimeFilterType.THIS_YEAR"
                                                  icon-color-h name="fas-info-circle"
                                                  [title]="'This amount is calculated over the selected period.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div class="txt-a-16-7">
                                        {{ showNullData ? NULL_DATA : isDefined(response.costs.ec_gse_cost) ? (-response.costs.ec_gse_cost|niceValue: '€':2: true) : NULL_DATA }}
                                    </div>
                                </div>
                                <div *ngIf="isCondom" fxLayout="column" class="panel-4 br-10">
                                    <div fxLayout="row" fxLayoutGap="20px">
                                        <app-icon icon-color-h name="fas-info-circle"></app-icon>
                                        <div class="txt-h-14-4">{{ condomGSETooltip|i18n }}</div>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px"
                                 *ngIf="membershipFeeEnable && isWholeYear">
                                <div fxLayoutGap="20px" fxLayoutAlign="start center">
                                    <span class="txt-h-18-7">{{ 'Membership Fee'|i18n }}</span>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="'Total quotes calculated on active members for the selected year.'|i18n">
                                    </app-icon>
                                </div>
                                <hr class="divider">
                                <div fxLayout="column" class="panel-4 br-10"
                                     *ngIf="!isDefined(response.membership_fee)">
                                    <div fxLayout="row" fxLayoutGap="20px">
                                        <app-icon icon-color-h name="fas-info-circle"></app-icon>
                                        <span class="txt-h-16-4">{{ 'Optional configuration'|i18n }}</span>
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center"
                                     *ngIf="isDefined(response.membership_fee)">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                        <div fxLayout="column" fxLayoutAlign="center start">
                                            <span class="txt-h-12-7">{{ 'Total fee'|i18n }}</span>
                                            <span class="txt-s-12-4"
                                                  *ngIf="computePayingMembers > 0">{{ response.membership_fee|niceValue: '€':2 }} {{ '*' }} {{ (computePayingMembers|niceValue:'':0) }} {{ 'members'|i18n }}
                                                =</span>
                                        </div>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start end" fxFlex="40">
                                        <span class="txt-h-16-7">{{ showNullData ? '-' : (response.total_membership_fee|niceValue:'€':2) }}</span>
                                    </div>
                                </div>
                                <div fxLayoutAlign="center center" class="mt-10">
                                    <button app-ghost-button (click)="onClickMembershipSetup()"
                                            [disabled]="!isWholeYear || this.response.gse || !isUpdatable(entity) || showNullData">
                                        <app-icon name="fal-pen-square"></app-icon>
                                        {{ 'Membership fee configuration'|i18n }}
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="response.gse" fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px">
                                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
                                        <app-icon class="icon-color" name="fal-chart-line"></app-icon>
                                        <div class="txt-h-18-7">{{ 'Comparison of estimates and GSE'|i18n }}</div>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'The comparison is intended to be net of costs.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
                                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                                            <span class="legend-dot forecast"></span>
                                            <span class="txt-s-12-4">{{ 'Estimated value'|i18n }}</span>
                                        </div>
                                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                                            <span class="legend-dot accent"></span>
                                            <span class="txt-s-12-4">{{ 'GSE data'|i18n }}</span>
                                        </div>
                                    </div>
                                </div>
                                <hr class="divider">
                                <span class="txt-h-14-7 mb-15">
                                    {{ 'Incentive__{eco}'|i18n }}
                                </span>
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                        <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                        <div class="txt-h-12-4">{{ 'Premium Incentive Rate (TIP)'|i18n }}:</div>
                                    </div>
                                    <div fxFlex="25" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                                        <span class="color-forecast txt-h-14-7">
                                            {{ showNullData ? NULL_DATA : (response.incentivation.estimated_gross_tip|niceValue: '€':2: true) }}
                                        </span>
                                        <span class="txt-acc-16-7">
                                            {{ showNullData ? NULL_DATA : (response.incentivation.gross_tip|niceValue: '€':2: true) }}
                                        </span>
                                    </div>
                                    <div fxFlex="10" fxLayoutAlign="start start" fxLayoutGap="5px">
                                        <span class="txt-s-12-4">
                                            {{ showNullData ? NULL_DATA : (computeDifference(response.incentivation.estimated_gross_tip, response.incentivation.gross_tip)|niceValue: '%':2: true) }}
                                        </span>
                                    </div>
                                </div>

                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                        <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                        <div class="txt-h-12-4"
                                             [innerHTML]="'Contribution enhancement energy self-consumed electricity ({0}):'|i18n: CACV_STRING">
                                            :
                                        </div>
                                    </div>
                                    <div fxFlex="25" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                                        <span class="color-forecast txt-h-14-7">
                                            {{ showNullData ? NULL_DATA : (response.incentivation.estimated_gross_c_acv|niceValue: '€':2: true) }}
                                        </span>
                                        <span class="txt-acc-16-7">
                                            {{ showNullData ? NULL_DATA : (response.incentivation.gross_c_acv|niceValue: '€':2: true) }}
                                        </span>
                                    </div>
                                    <div fxFlex="10" fxLayoutAlign="start start" fxLayoutGap="5px">
                                        <span class="txt-s-12-4">
                                            {{ showNullData ? NULL_DATA : (computeDifference(response.incentivation.estimated_gross_c_acv, response.incentivation.gross_c_acv)|niceValue: '%':2: true) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div fxLayout="column" fxLayoutGap="10px" fxFlex="24">
                            <div *ngIf="showCosts" fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                        <div class="txt-h-18-7">{{ 'Expenses'|i18n }}</div>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Manually configured costs and provisions.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                        <app-icon *ngIf="missingCosts(response,this.strategy)"
                                                  icon-color-w name="fas-exclamation-triangle"
                                                  [title]="'Configure expenses'|i18n">
                                        </app-icon>
                                        <div class="txt-a-24-7">
                                            {{
                                                showNullData || missingCosts(response,this.strategy) ?
                                                    NULL_DATA :
                                                    (-getSum(response.costs.cost_values)|niceValue: '€':2: true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <hr class="divider">
                                <ng-container *ngIf="!response.costs.costs">
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <span class="txt-h-12-4 mt-10">{{ ('You have not yet configured any entry'|i18n) + '.' }}</span>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="response.costs.costs && response.costs.cost_values.length > 0">
                                    <div *ngFor="let c of response.costs.cost_values; let i = index" fxLayout="row"
                                         fxLayoutAlign="space-between start">
                                        <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start">
                                            <div fxFlex="15" fxLayout="row">
                                                <app-icon name="fal-piggy-bank"
                                                          class="small-icon icon-color"></app-icon>
                                            </div>
                                            <div fxLayout="column" fxLayoutGap="5px">
                                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center"
                                                     fxLayoutGap="15px">
                                                    <div class="txt-h-12-7">{{ response.costs.costs.costs[i].name }}</div>
                                                </div>
                                                <div class="txt-s-12-4" [ngSwitch]="response.costs.costs.costs[i].type">
                                                    <div *ngSwitchCase="ECCostType.SHARED_ENERGY">
                                                        <span>€ {{ response.costs.costs.costs[i].cost|niceValue: '':2 }}
                                                            /MWh</span>
                                                    </div>
                                                    <div *ngSwitchCase="ECCostType.POD">
                                                        <span>€ {{ response.costs.costs.costs[i].cost|niceValue: '':2 }} {{ 'for POD'|i18n }}</span>
                                                    </div>
                                                    <div *ngSwitchCase="ECCostType.PERCENTAGE">
                                                        <span *ngIf="response.costs.costs.use_c_acv">{{ response.costs.costs.costs[i].cost * 100|niceValue: '':2 }}
                                                            % {{ 'of Incentive'|i18n }}</span>
                                                        <span *ngIf="!response.costs.costs.use_c_acv">{{ response.costs.costs.costs[i].cost * 100|niceValue: '':2 }}
                                                            % {{ 'of TIP'|i18n }}</span>
                                                    </div>
                                                    <div *ngSwitchCase="ECCostType.PERCENTAGE_LOWERBOUND">
                                                         <span *ngIf="response.costs.costs.use_c_acv">{{ response.costs.costs.costs[i].cost * 100|niceValue: '':2 }}
                                                             % {{ 'of Incentive'|i18n }}</span>
                                                        <span *ngIf="!response.costs.costs.use_c_acv">{{ response.costs.costs.costs[i].cost * 100|niceValue: '':2 }}
                                                            % {{ 'of TIP'|i18n }}</span>
                                                    </div>
                                                    <div *ngSwitchCase="ECCostType.FIXED">
                                                        <span>€ {{ response.costs.costs.costs[i].cost|niceValue: '':2 }}
                                                            {{ 'Yearly'|i18n }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
                                            <div *ngIf="response.costs.costs.costs[i].type === ECCostType.POD">
                                                <app-icon *ngIf="billingPeriod.type === TimeFilterType.THIS_YEAR"
                                                          icon-color-h name="fas-info-circle"
                                                          [title]="'This amount is calculated over a period up to the present.'|i18n">
                                                </app-icon>
                                                <app-icon *ngIf="billingPeriod.type !== TimeFilterType.THIS_YEAR"
                                                          icon-color-h name="fas-info-circle"
                                                          [title]="'This amount is calculated over the selected period.'|i18n">
                                                </app-icon>
                                            </div>
                                            <div *ngIf="response.costs.costs.costs[i].type === ECCostType.PERCENTAGE_LOWERBOUND">
                                                <app-icon *ngIf="billingPeriod.type === TimeFilterType.THIS_YEAR"
                                                          icon-color-h name="fas-info-circle"
                                                          [title]="'This amount is calculated over a period up to the present.'|i18n">
                                                </app-icon>
                                                <app-icon *ngIf="billingPeriod.type !== TimeFilterType.THIS_YEAR"
                                                          icon-color-h name="fas-info-circle"
                                                          [title]="'This amount is calculated over the selected period.'|i18n">
                                                </app-icon>
                                            </div>
                                            <div *ngIf="response.costs.costs.costs[i].type === ECCostType.FIXED">
                                                <app-icon *ngIf="billingPeriod.type === TimeFilterType.THIS_YEAR"
                                                          icon-color-h name="fas-info-circle"
                                                          [title]="'This amount is calculated over a period up to the present.'|i18n">
                                                </app-icon>
                                                <app-icon *ngIf="billingPeriod.type !== TimeFilterType.THIS_YEAR"
                                                          icon-color-h name="fas-info-circle"
                                                          [title]="'This amount is calculated over the selected period.'|i18n">
                                                </app-icon>
                                            </div>
                                            <span class="txt-a-16-7">
                                            {{ showNullData ? NULL_DATA : (-c|niceValue: '€':2: true) }}
                                        </span>
                                        </div>
                                    </div>
                                </ng-container>
                                <div fxLayout="row" fxLayoutAlign="center center" class="mt-20" *ngIf="enableFeatures(ECEconomicsFeatures.CONFIGURABLE_COSTS)">
                                    <button app-ghost-button
                                            [disabled]="disableCostsConfiguration(entity)"
                                            (click)="onClickCostsSetup()">
                                        {{ 'Configure'|i18n }}
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="showNetIncentive" fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                        <div class="txt-h-18-7">{{ 'Net incentive'|i18n }}</div>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Incentive resulting from the application of output items.'|i18n">
                                        </app-icon>
                                    </div>
                                    <span class="txt-h-24-7"> {{ netIncentive }} </span>
                                </div>
                                <hr class="divider">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                        <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                        <div class="txt-h-12-4">{{ 'Premium Incentive Rate (TIP)'|i18n }}:</div>
                                    </div>
                                    <div class="txt-h-16-7">
                                        {{
                                            showNullData || missingCosts(response,this.strategy) ?
                                                NULL_DATA :
                                                (response.incentivation.net_tip|niceValue: '€':2: true)
                                        }}
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                        <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                        <div class="txt-h-12-4"
                                             [innerHTML]="'Contribution enhancement energy self-consumed electricity ({0}):'|i18n: CACV_STRING">
                                            :
                                        </div>
                                    </div>
                                    <div class="txt-h-16-7">
                                        {{
                                            showNullData || missingCosts(response,this.strategy) ?
                                                NULL_DATA :
                                                (response.incentivation.net_c_acv|niceValue: '€':2: true)
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px"
                                 *ngIf="isWholeYear && enableFeatures(ECEconomicsFeatures.SURPLUS_PREMIUM_RATE)">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center" fxFlex="41">
                                        <div class="txt-h-18-7" fxLayout="row">{{ 'Exceeding TIP'|i18n }}</div>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Possible amount of surplus premium rate that exceeds the shared energy threshold for incentives, corresponding to 55% or 45% if there are plants with capital grant contribution. This amount can be allocated to off-take utilities or set aside for social purposes inherent in the territory of the plants.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div class="txt-h-24-7" fxLayout="row" fxFlex="40" fxLayoutAlign="end center">
                                        {{
                                            showNullData || missingCosts(response,this.strategy) ? NULL_DATA :
                                                (response.surplus_premium_rate.premium_rate|niceValue: '€':2)
                                        }}
                                    </div>
                                </div>
                                <hr class="divider">
                                <div *ngIf="!showNullData" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxFlex></div>
                                    <!--                                    <div *ngIf="!response.surplus_premium_rate.has_surplus" fxLayout="row" fxLayoutAlign="space-around center"-->
                                    <!--                                         class="txt-s-14-4 color-accent" fxLayoutGap="8px">-->
                                    <!--                                        <app-icon name="fal-check-circle"></app-icon>-->
                                    <!--                                        <div>{{'No excess'|i18n}}</div>-->
                                    <!--                                    </div>-->
                                    <div *ngIf="response.surplus_premium_rate.scope === ECSurplusPremiumRateScope.ALLOCATED"
                                         fxLayout="row" fxLayoutAlign="space-around center"
                                         class="txt-s-14-4" fxLayoutGap="8px">
                                        <app-icon name="fal-arrow-right"></app-icon>
                                        <app-icon name="fal-piggy-bank"></app-icon>
                                        <div>{{ 'Saved as fund'|i18n }}</div>
                                    </div>
                                    <div *ngIf="response.surplus_premium_rate.scope === ECSurplusPremiumRateScope.CONSUMER_REDISTRIBUTED"
                                         fxLayout="row" fxLayoutAlign="space-around center"
                                         class="txt-s-14-4" fxLayoutGap="8px">
                                        <app-icon name="fal-arrow-right"></app-icon>
                                        <app-icon name="fal-plug"></app-icon>
                                        <div>{{ 'Intended for non-enterprise absorptions'|i18n }}</div>
                                    </div>
                                    <div *ngIf="response.surplus_premium_rate.scope === ECSurplusPremiumRateScope.UNDEFINED"
                                         fxLayout="row" fxLayoutAlign="space-around center"
                                         class="txt-s-14-4" fxLayoutGap="8px">
                                        <app-icon name="fas-exclamation-triangle" icon-color-w
                                                  [title]="'Use the algorithm configuration form to choose where to allocate this amount.'|i18n"></app-icon>
                                        <app-icon name="fal-arrow-right"></app-icon>
                                        <div>{{ 'To be allocated'|i18n }}</div>
                                    </div>
                                </div>
                                <div *ngIf="!showNullData" fxLayout="column" fxLayoutGap="10px">
                                    <div class="mt-8 txt-h-14-7">
                                        {{ ('Incentivable shared energy ratio non surplus'|i18n) + ':' }}
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                            <app-icon name="fal-solar-panel" class="small-icon icon-color"></app-icon>
                                            <div class="txt-h-12-4">{{ 'Plants with capital grant'|i18n }}:</div>
                                        </div>
                                        <div class="txt-h-16-7">
                                            {{
                                                showNullData || missingCosts(response,this.strategy) ? '-' :
                                                    (response.surplus_premium_rate.capital_grant_shared_performance * 100|niceValue: '%')
                                            }}
                                        </div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                            <app-icon name="fal-solar-panel" class="small-icon icon-color"></app-icon>
                                            <div class="txt-h-12-4">{{ 'Plants without capital grant'|i18n }}:</div>
                                        </div>
                                        <div class="txt-h-16-7">
                                            {{
                                                showNullData || missingCosts(response,this.strategy) ? '-' :
                                                    (response.surplus_premium_rate.shared_performance * 100|niceValue: '%')
                                            }}
                                        </div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-16">
                                        <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                            <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                            <div fxLayout="column">
                                                <div class="txt-h-12-4">{{ 'Maximum redistributable for companies'|i18n }}
                                                    :
                                                </div>
                                                <div class="txt-h-12-4"> ({{ 'Net TIP'|i18n }}
                                                    - {{ 'Exceeding TIP'|i18n }})
                                                </div>
                                            </div>
                                        </div>
                                        <div class="txt-h-16-7">
                                            {{
                                                showNullData || missingCosts(response,this.strategy) ? '-' :
                                                    (response.surplus_premium_rate.maximum_tip|niceValue: '€':2:true)
                                            }}
                                        </div>
                                    </div>
                                    <div *ngIf="response.surplus_premium_rate.plants_tip_over_maximum" fxLayout="row"
                                         fxLayoutAlign="center center" fxLayoutGap="18px"
                                         economics-warning class="padding-12 mt-18">
                                        <app-icon icon-color-w name="fas-info-circle"></app-icon>
                                        <div>{{ 'Maximum redistributable to companies exceeded by the plants redistributable'|i18n }}</div>
                                    </div>
                                </div>
                                <div *ngIf="showNullData">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxFlex="65" class="txt-h-12-4" fxLayoutAlign="start start">
                                            {{ 'Shared energy ratio'|i18n }}
                                        </div>
                                        <div class="txt-h-16-7">
                                            {{ NULL_PERCENTAGE }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px" fxFlex="24">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                    <div class="txt-h-18-7">{{ 'Community facilities'|i18n }}</div>
                                </div>
                                <span *ngIf="!isRepresentative" class="txt-h-24-7">
                                    {{ showNullData || hasNoEcPlants ? NULL_DATA : (response.plants.ec_plants_rei|niceValue: '€':2: response.plants.ec_plants_rei < 0) }}
                                </span>
                            </div>
                            <hr class="divider">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4">{{ 'Withdrawal of energy fed into plants community-owned'|i18n }}
                                        :
                                    </div>
                                </div>
                                <span class="txt-h-16-7">
                                {{ showNullData || hasNoEcPlants ? NULL_DATA : (response.plants.ec_plants_rei|niceValue: '€':2: true) }}
                            </span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20">
                                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                    <div class="txt-h-18-7">{{ 'Members facilities'|i18n }}</div>
                                </div>
                                <span *ngIf="!isRepresentative" class="txt-h-24-7">
                                    {{ showNullData || hasNoMemberPlants ? NULL_DATA : (getSum([response.plants.member_plants_rei, response.plants.member_plants_tip, isDefined(response.plants.member_plants_c_acv) ? response.plants.member_plants_c_acv : 0])|niceValue: '€':2: getSum([response.plants.member_plants_rei, response.plants.member_plants_tip, isDefined(response.plants.member_plants_c_acv) ? response.plants.member_plants_c_acv : 0]) < 0) }}
                                </span>
                            </div>
                            <hr class="divider">
                            <div *ngIf="!isRepresentative" fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4">{{ 'Total withdrawal'|i18n }}:</div>
                                </div>
                                <div class="txt-h-16-7">
                                    {{
                                        showNullData || hasNoMemberPlants ?
                                            NULL_DATA :
                                            (response.plants.member_plants_rei|niceValue: '€':2: true)
                                    }}
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4">{{ 'TIP ceded by the community'|i18n }}:</div>
                                </div>
                                <div class="txt-h-16-7">
                                    <ng-container *ngIf="showNullData || hasNoMemberPlants">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="!showNullData && !hasNoMemberPlants">
                                        <app-icon
                                                *ngIf="missingTipQuoteWithType(response, ECMemberParticipationType.MEMBER, this.strategy)"
                                                [title]="'Configure TIP quote withheld by plants'|i18n"
                                                class="mr-10" icon-color-w name="fas-exclamation-triangle">
                                        </app-icon>
                                        {{ response.plants.member_plants_tip|niceValue: '€':2: true }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4" [innerHTML]="'Net {0}'|i18n: CACV_STRING">:</div>
                                </div>
                                <!-- if everything is misconfigured then show only '-' -->
                                <div *ngIf="showNullData || hasNoMemberPlants || missingCacvMode(response, this.strategy)"
                                     class="txt-h-16-7">
                                    {{ NULL_DATA }}
                                </div>
                                <!-- if everything is configured then show the value -->
                                <div *ngIf="!showNullData && !hasNoMemberPlants && !missingCacvMode(response, this.strategy)"
                                     class="txt-h-16-7">
                                    {{ response.plants.member_plants_c_acv|niceValue: '€':2: true }}
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20">
                                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center" class="txt-h-18-7">
                                    {{ 'Thirds facilities'|i18n }}
                                </div>
                                <div *ngIf="!isRepresentative" class="txt-h-24-7">
                                    {{
                                        showNullData || hasNoThirdPlants ?
                                            NULL_DATA :
                                            (getSum([response.plants.third_party_plants_rei, response.plants.third_party_plants_tip, isDefined(response.plants.third_party_plants_c_acv) ? response.plants.third_party_plants_c_acv : 0])|niceValue: '€':2: getSum([response.plants.third_party_plants_rei, response.plants.third_party_plants_tip, isDefined(response.plants.third_party_plants_c_acv) ? response.plants.third_party_plants_c_acv : 0]) < 0)
                                    }}
                                </div>
                            </div>
                            <hr class="divider">
                            <div *ngIf="!isRepresentative" fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4">{{ 'Total withdrawal'|i18n }}:</div>
                                </div>
                                <div class="txt-h-16-7">
                                    {{
                                        showNullData || hasNoThirdPlants ?
                                            NULL_DATA :
                                            (response.plants.third_party_plants_rei|niceValue: '€':2: true)
                                    }}
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4">{{ 'TIP ceded by the community'|i18n }}:</div>
                                </div>
                                <div class="txt-h-16-7">
                                    <ng-container *ngIf="showNullData || hasNoThirdPlants">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="!showNullData && !hasNoThirdPlants">
                                        <app-icon
                                                *ngIf="missingTipQuoteWithType(response, ECMemberParticipationType.THIRD_PARTY_PRODUCER, this.strategy)"
                                                [title]="'Configure TIP quote withheld by plants'|i18n"
                                                class="mr-10" icon-color-w name="fas-exclamation-triangle">
                                        </app-icon>
                                        {{ response.plants.third_party_plants_tip|niceValue: '€':2: true }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                                    <app-icon name="fal-piggy-bank" class="small-icon icon-color"></app-icon>
                                    <div class="txt-h-12-4" [innerHTML]="'Net {0}'|i18n: CACV_STRING">:</div>
                                </div>
                                <!-- if everything is misconfigured then show only '-' -->
                                <div *ngIf="showNullData || hasNoThirdPlants || missingCacvMode(response, this.strategy)"
                                     class="txt-h-16-7">
                                    {{ NULL_DATA }}
                                </div>
                                <!-- if everything is configured then show the value -->
                                <div *ngIf="!showNullData && !hasNoThirdPlants && !missingCacvMode(response, this.strategy)"
                                     class="txt-h-16-7">
                                    {{ response.plants.third_party_plants_c_acv|niceValue: '€':2: true }}
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" class="mt-20">
                                <button app-ghost-button (click)="onClickPlantsDetails()" [disabled]="showNullData">
                                    {{ 'Plants list'|i18n }}
                                </button>
                            </div>
                        </div>

                        <div fxLayout="column" class="panel-3 br-20" fxLayoutGap="10px" fxFlex="24">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
                                    <app-icon class="icon-color" name="fal-plug"></app-icon>
                                    <div class="txt-h-18-7">{{ redistributedWithdrawalsLabel }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="'Total net revenue to be allocated among withdrawing utilities.'|i18n">
                                    </app-icon>
                                    <app-icon *ngIf="missingRedistributionSettings(response)" icon-color-w
                                              name="fas-exclamation-triangle"
                                              [title]="'Please configure the redistribution algorithm'|i18n">
                                    </app-icon>
                                </div>
                                <div class="txt-h-24-7">
                                    <ng-container *ngIf="showNullData ||
                                                         (hasNoEcPlants && hasNoMemberPlants && hasNoThirdPlants) ||
                                                         missingCosts(response,this.strategy)">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="!showNullData &&
                                                         !(hasNoEcPlants && hasNoMemberPlants && hasNoThirdPlants) &&
                                                         !missingCosts(response,this.strategy)">
                                        {{ redistributedWithdrawals|niceValue: '€':2: redistributedWithdrawals < 0 }}
                                    </ng-container>
                                </div>
                            </div>
                            <hr class="divider">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" class="txt-h-12-4">
                                    {{ redistributedPlantsWithdrawalLabel|i18n }}:
                                </div>
                                <div class="txt-h-16-7">
                                    <ng-container *ngIf="(showNullData || hasNoEcPlants) && !isCondom">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="(!showNullData && !hasNoEcPlants) || isCondom">
                                        <app-icon *ngIf="missingReiRedistribution(response,this.strategy)"
                                                  [title]="'Configure plant quote from withdrawal'|i18n"
                                                  class="mr-10" icon-color-w name="fas-exclamation-triangle">
                                        </app-icon>
                                        {{ response.redistribution.redistributable_ec_plants_rei|niceValue: '€':2: response.redistribution.redistributable_ec_plants_rei < 0 }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start" class="txt-h-12-4">
                                    {{ redistributedTipLabel|i18n }}:
                                </div>
                                <div class="txt-h-16-7">
                                    <ng-container
                                            *ngIf="showNullData || missingCosts(response,this.strategy)">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="!(showNullData || missingCosts(response,this.strategy))">
                                        <app-icon *ngIf="missingTipQuoteWithType(response, ECMemberParticipationType.THIRD_PARTY_PRODUCER, this.strategy) ||
                                                     missingTipQuoteWithType(response, ECMemberParticipationType.MEMBER, this.strategy)"
                                                  [title]="'Configure TIP quote withheld by plants'|i18n" class="mr-10"
                                                  icon-color-w
                                                  name="fas-exclamation-triangle">
                                        </app-icon>
                                        {{ (response.redistribution.redistributable_tip|niceValue: '€':2: response.redistribution.redistributable_tip < 0) }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxFlex="65" fxLayout="row" fxLayoutAlign="start start">
                                    <div class="txt-h-12-4" [innerHTML]="redistributedCacvLabel">:</div>
                                </div>
                                <div class="txt-h-16-7">
                                    <app-icon
                                            *ngIf="!showNullData && !missingCosts(response,this.strategy) && missingCacvMode(response, this.strategy)"
                                            icon-color-w name="fas-exclamation-triangle" class="mr-10"
                                            [title]="'Configure the destination of CACV'|i18n">
                                    </app-icon>
                                    <ng-container *ngIf="showNullData || missingCosts(response,this.strategy) ||
                                            !isDefined(response.redistribution.redistributable_c_acv)"
                                                  class="txt-h-16-7">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="!showNullData && !missingCosts(response,this.strategy) &&
                                            isDefined(response.redistribution.redistributable_c_acv)"
                                                  class="txt-h-16-7">
                                        {{ (response.redistribution.redistributable_c_acv|niceValue: '€':2: response.redistribution.redistributable_c_acv < 0) }}
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="center center" class="panel-3 br-20 w-100">
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <span class="txt-h-14-7">{{ 'Parameters'|i18n }}</span>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                    <span class="txt-s-12-7">{{ 'TRASe BT' }}:</span>
                                    <span class="txt-s-12-4">{{ (showNullData || !response.params.trase_bt) ? '- €/MWh' : response.params.trase_bt|niceValue: '€/MWh':2 }}</span>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="'TRASe BT: transmission tariff on low voltage.'|i18n">
                                    </app-icon>
                                </div>

                                <ng-container
                                        *ngIf="entity.sub_type === EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <span class="txt-s-12-7">{{ 'BTAU' }}:</span>
                                        <span class="txt-s-12-4">{{ (showNullData || !response.params.btau) ? '-' : response.params.btau|niceValue: '€/MWh':2 }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'BTAU: the maximum among low-voltage distribution variable components.'|i18n">
                                        </app-icon>
                                    </div>

                                    <div *ngIf="!!response.params.nl_bt"
                                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <span class="txt-s-12-7" [innerHTML]="CPR_BT_STRING + ':'"></span>
                                        <span class="txt-s-12-4">{{ showNullData ? '-' : (response.params.nl_bt * 100)|niceValue: '%':2 }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Low voltage network loss coefficient.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div *ngIf="!!response.params.nl_mt"
                                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <span class="txt-s-12-7" [innerHTML]="CPR_MT_STRING + ':'"></span>
                                        <span class="txt-s-12-4">{{ showNullData ? '-' : (response.params.nl_mt * 100)|niceValue: '%':2 }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Medium voltage network loss coefficient.'|i18n">
                                        </app-icon>
                                    </div>
                                </ng-container>

                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <button app-ghost-button (click)="onClickMarketIndicators()"
                                            [disabled]="showNullData">
                                        {{ 'Energy market indicators'|i18n }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Dati energetici -->
                <div fxLayout="column" fxLayoutGap="20px" *ngIf="!this.inactiveEc && !this.futureEc">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="txt-h-18-7" fxFlex="36">{{ 'Energy data'|i18n }}</span>
                        <div fxFlex="22"></div>
                        <div *ngIf="response.gse" fxFlex="36" fxLayout="row" fxLayoutAlign="end center">
                            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
                                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                                    <span class="legend-dot accent-variant"></span>
                                    <span class="txt-s-12-4">{{ 'Estimated value'|i18n }}</span>
                                </div>
                                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                                    <span class="legend-dot accent"></span>
                                    <span class="txt-s-12-4">{{ 'GSE data'|i18n }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-evenly stretch">
                        <div fxLayout="row" class="panel-7 br-10" fxLayoutAlign="space-between stretch" fxFlex="37">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="40">
                                <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="10px" fxFlex="50">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-h name="fal-solar-panel"></app-icon>
                                        <span class="txt-h-16-7">{{ 'Produced energy__{eco}'|i18n }}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                  class="small-icon"></app-icon>
                                        <span class="txt-e-18-7">{{ response.energy.produced_energy|niceValue:'kWh' }}</span>
                                    </div>
                                </div>
                                <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="10px" fxFlex="50">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-h name="fal-solar-panel"></app-icon>
                                        <span class="txt-h-16-7">{{ 'Injected energy'|i18n }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'It is the electricity actually fed into the grid plus conventional loss coefficients, as provided for in Article 76 of ARERA\'s TIS, to take into account electricity losses on transmission and distribution grids and used for energy retirement purposes.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                  class="small-icon"></app-icon>
                                        <span class="txt-e-18-7">{{ response.energy.injected_energy|niceValue:'kWh' }}</span>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="20px" fxFlex="56">
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-h name="fal-sync-alt"></app-icon>
                                        <span class="txt-h-16-7">{{ 'Physical self consumption'|i18n }}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                  class="small-icon"></app-icon>
                                        <span class="txt-e-18-7">{{ response.energy.self_consumed_energy|niceValue:'kWh' }}</span>
                                    </div>
                                </div>
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
                                        <span class="txt-s-16-7">{{ 'Physical self consumption performance'|i18n }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'How much of the produced energy was self-consumed directly by the community prosumers'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                                        <div *ngIf="isDefined(response.energy.self_consumption_performance)"
                                             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                            <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                      class="small-icon"></app-icon>
                                            <span class="txt-e-18-7">{{ (response.energy.self_consumption_performance * 100)|niceValue:'%' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="20" fxLayoutGap="15px"
                             class="pt-pb-15 br-10">
                            <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="10px" fxFlex="47">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-home"></app-icon>
                                    <span class="txt-h-16-7">{{ 'Consumed energy'|i18n }}</span>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                    <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                              class="small-icon"></app-icon>
                                    <span class="txt-e-18-7">{{ response.energy.consumed_energy|niceValue:'kWh' }}</span>
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="panel-6 br-10"
                                     fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <div class="txt-s-16-7">{{ 'Saved {0}'|i18n:'CO&#8322;' }}</div>
                                        <div class="txt-e-14-7">{{ response.energy.saved_co2 / 1000000|niceValue:'t' }}</div>
                                    </div>
                                    <app-icon icon-color-h name="fas-info-circle" class="small-icon"
                                              [title]="co2Title"></app-icon>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="panel-6 br-10">
                                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <div class="txt-s-16-7">{{ 'Saved natural gas'|i18n }}</div>
                                        <div class="txt-e-14-7">{{ response.energy.saved_gas|niceValue:'Smc' }}</div>
                                    </div>
                                    <app-icon icon-color-h name="fas-info-circle" class="small-icon"
                                              [title]="gasTitle"></app-icon>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" class="panel-7 br-10" fxLayoutAlign="space-between stretch" fxFlex="40">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="48">
                                <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="10px" fxFlex="50">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-h name="fal-plug"></app-icon>
                                        <span class="txt-h-16-7">{{ 'Absorbed energy'|i18n }}</span>
                                    </div>
                                    <div fxLayout="row wrap" fxLayoutAlign="space-between start">
                                        <ng-container
                                                *ngIf="response.gse && isDefined(response.energy.absorbed_energy)">
                                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                          class="small-icon"></app-icon>
                                                <span class="txt-e-14-7">{{ response.energy.estimated_absorbed_energy|niceValue:'kWh' }}</span>
                                            </div>
                                            <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <app-icon icon-color-s name="fal-check-circle"
                                                              class="small-icon"></app-icon>
                                                    <span class="txt-acc-18-7">{{ response.energy.absorbed_energy|niceValue:'kWh' }}</span>
                                                </div>
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <app-icon icon-color-s name="fal-arrow-up"
                                                              class="small-icon"></app-icon>
                                                    <span class="txt-s-12-4">{{ computeDifference(response.energy.estimated_absorbed_energy, response.energy.absorbed_energy)|niceValue:'%':2 }}</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <div *ngIf="!response.gse && isDefined(response.energy.estimated_absorbed_energy)"
                                             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                            <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                      class="small-icon"></app-icon>
                                            <span class="txt-e-14-7">{{ response.energy.estimated_absorbed_energy|niceValue:'kWh' }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-h name="fal-paper-plane"></app-icon>
                                        <span class="txt-h-16-7">{{ 'Effective injected energy'|i18n }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Electricity actually fed in from feed-in points without the addition of conventional loss coefficients and used to determine shared energy.'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <ng-container
                                                *ngIf="response.gse && isDefined(response.energy.effective_injected_energy)">
                                            <div fxLayout="column" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                    <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                              class="small-icon"></app-icon>
                                                    <span class="txt-e-14-7">{{ response.energy.estimated_effective_injected_energy|niceValue:'kWh' }}</span>
                                                    <div fxLayout="column" fxLayoutAlign="start start"
                                                         fxLayoutGap="10px">
                                                        <div fxLayout="row" fxLayoutAlign="start center"
                                                             fxLayoutGap="10px">
                                                            <app-icon icon-color-s name="fal-check-circle"
                                                                      class="small-icon"></app-icon>
                                                            <span class="txt-acc-18-7">{{ response.energy.effective_injected_energy|niceValue:'kWh' }}</span>
                                                        </div>
                                                        <div fxLayout="row" fxLayoutAlign="start center"
                                                             fxLayoutGap="10px">
                                                            <app-icon icon-color-s name="fal-arrow-up"
                                                                      class="small-icon"></app-icon>
                                                            <span class="txt-s-12-4">{{ computeDifference(response.energy.estimated_effective_injected_energy, response.energy.effective_injected_energy)|niceValue:'%':2 }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
                                                     *ngIf="response.plants.non_incentivized_plants_count > 0">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                        <app-icon icon-color-h name="fal-piggy-bank"
                                                                  class="small-icon"></app-icon>
                                                        <div class="txt-h-12-4">{{ 'of which coming from incentivized plants'|i18n }}
                                                            :
                                                        </div>
                                                    </div>
                                                    <div fxLayout="column" fxLayoutGap="10px">
                                                        <div class="txt-e-14-7" fxLayout="row" fxLayoutGap="2px">
                                                            <span>{{ response.energy.estimated_incentive_effective_injected_energy|niceValue:'kWh' }} </span>
                                                            <app-icon icon-color-h name="fas-info-circle"
                                                                      [title]="'Effective injected energy coming from plants incentivized by the regulations'|i18n">
                                                            </app-icon>
                                                        </div>
                                                        <div class="txt-acc-18-7">
                                                            {{ response.energy.incentive_effective_injected_energy|niceValue:'kWh' }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container
                                                *ngIf="!response.gse && isDefined(response.energy.estimated_effective_injected_energy)">
                                            <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                              class="small-icon"></app-icon>
                                                    <span class="txt-e-14-7">{{ response.energy.estimated_effective_injected_energy|niceValue:'kWh' }}</span>
                                                </div>
                                                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
                                                     *ngIf="response.plants.non_incentivized_plants_count > 0">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                                                         fxFlex="50">
                                                        <app-icon icon-color-h name="fal-piggy-bank"
                                                                  class="small-icon"></app-icon>
                                                        <div class="txt-h-12-4">{{ 'of which coming from incentivized plants'|i18n }}
                                                            :
                                                        </div>
                                                    </div>
                                                    <div fxLayout="column" fxLayoutGap="10px">
                                                        <div class="txt-e-14-7">
                                                            {{ response.energy.estimated_incentive_effective_injected_energy|niceValue:'kWh' }}
                                                        </div>
                                                    </div>
                                                    <app-icon icon-color-h name="fas-info-circle"
                                                              [title]="'Effective injected energy coming from plants incentivized by the regulations'|i18n">
                                                    </app-icon>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="column" class="panel-6 br-10" fxLayoutGap="20px" fxFlex="48">
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                        <app-icon icon-color-h name="fal-bolt"></app-icon>
                                        <span class="txt-h-16-7">{{ 'Shared energy'|i18n }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'Energy virtually self-consumed by community members through the distribution network'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                                        <ng-container *ngIf="response.gse && isDefined(response.energy.shared_energy) &&
                                                             isDefined(response.energy.incentive_shared_energy)">
                                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                    <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                              class="small-icon"></app-icon>
                                                    <div class="txt-e-14-7">{{ response.energy.estimated_shared_energy|niceValue:'kWh' }}</div>
                                                </div>
                                                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                        <app-icon icon-color-s name="fal-check-circle"
                                                                  class="small-icon"></app-icon>
                                                        <div class="txt-acc-18-7">{{ response.energy.shared_energy|niceValue:'kWh' }}</div>
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                        <app-icon icon-color-s name="fal-arrow-up"
                                                                  class="small-icon"></app-icon>
                                                        <div class="txt-s-12-4">
                                                            {{ computeDifference(response.energy.estimated_shared_energy, response.energy.shared_energy)|niceValue:'%':2 }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
                                                 *ngIf="response.plants.non_incentivized_plants_count > 0">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <app-icon icon-color-h name="fal-piggy-bank"
                                                              class="small-icon"></app-icon>
                                                    <div class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                                                </div>
                                                <div fxLayout="column" fxLayoutGap="10px">
                                                    <div class="txt-e-14-7">
                                                        {{ response.energy.estimated_incentive_shared_energy|niceValue:'kWh' }}
                                                    </div>
                                                    <div class="txt-acc-18-7">
                                                        {{ response.energy.incentive_shared_energy|niceValue:'kWh' }}
                                                    </div>
                                                </div>
                                                <app-icon icon-color-h name="fas-info-circle"
                                                          [title]="'Shared energy for which plants having as incentive mode \'Old regulations\' or \'New regulations\' are getting TIP'|i18n">
                                                </app-icon>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="!response.gse && isDefined(response.energy.estimated_shared_energy) &&
                                                                                            isDefined(response.energy.estimated_incentive_shared_energy)">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                          class="small-icon"></app-icon>
                                                <div class="txt-e-14-7">{{ response.energy.estimated_shared_energy|niceValue:'kWh' }}</div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                                                 *ngIf="response.plants.non_incentivized_plants_count > 0">
                                                <app-icon icon-color-h name="fal-piggy-bank"
                                                          class="small-icon"></app-icon>
                                                <div class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                                                <div class="txt-e-14-7">
                                                    {{ response.energy.estimated_incentive_shared_energy|niceValue:'kWh' }}
                                                </div>
                                                <app-icon icon-color-h name="fas-info-circle"
                                                          [title]="'Shared energy for which plants having as incentive mode \'Old regulations\' or \'New regulations\' are getting TIP'|i18n">
                                                </app-icon>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
                                        <span class="txt-s-16-7">{{ 'Share performance'|i18n }}</span>
                                        <app-icon icon-color-h name="fas-info-circle"
                                                  [title]="'How much of the energy input alone was shared by the community, becoming shared energy'|i18n">
                                        </app-icon>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                                        <ng-container
                                                *ngIf="response.gse && isDefined(response.energy.share_performance)">
                                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                    <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                              class="small-icon"></app-icon>
                                                    <span class="txt-e-14-7">{{ response.energy.estimated_share_performance * 100|niceValue:'%':2 }}</span>
                                                </div>
                                                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                        <app-icon icon-color-s name="fal-check-circle"
                                                                  class="small-icon"></app-icon>
                                                        <span class="txt-acc-18-7">{{ response.energy.share_performance * 100|niceValue:'%':2 }}</span>
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                        <app-icon icon-color-s name="fal-arrow-up"
                                                                  class="small-icon"></app-icon>
                                                        <span class="txt-s-12-4">{{ computeDifference(response.energy.estimated_share_performance, response.energy.share_performance)|niceValue:'%':2 }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
                                                 *ngIf="response.plants.non_incentivized_plants_count > 0">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <app-icon icon-color-h name="fal-piggy-bank"
                                                              class="small-icon"></app-icon>
                                                    <div class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                                                </div>
                                                <div fxLayout="column" fxLayoutGap="10px">
                                                    <div class="txt-e-14-7">
                                                        {{ response.energy.estimated_incentive_share_performance * 100|niceValue:'%' }}
                                                    </div>
                                                    <div class="txt-acc-18-7">
                                                        {{ response.energy.incentive_share_performance * 100|niceValue:'%' }}
                                                    </div>
                                                </div>
                                                <app-icon icon-color-h name="fas-info-circle"
                                                          [title]="'Shared energy for which plants having as incentive mode \'Old regulations\' or \'New regulations\' are getting TIP'|i18n">
                                                </app-icon>
                                            </div>
                                        </ng-container>
                                        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px"
                                             *ngIf="!response.gse && isDefined(response.energy.estimated_share_performance)">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                <app-icon icon-color-s [name]="dataSourceInfo?.iconName"
                                                          class="small-icon"></app-icon>
                                                <span class="txt-e-14-7">{{ response.energy.estimated_share_performance * 100|niceValue:'%':2 }}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
                                                 *ngIf="response.plants.non_incentivized_plants_count > 0">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                    <app-icon icon-color-h name="fal-piggy-bank"
                                                              class="small-icon"></app-icon>
                                                    <div class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                                                </div>
                                                <div fxLayout="column" fxLayoutGap="10px">
                                                    <div class="txt-e-14-7">
                                                        {{ response.energy.estimated_incentive_share_performance * 100|niceValue:'%' }}
                                                    </div>
                                                </div>
                                                <app-icon icon-color-h name="fas-info-circle"
                                                          [title]="'Shared energy for which plants having as incentive mode \'Old regulations\' or \'New regulations\' are getting TIP'|i18n">
                                                </app-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <mat-expansion-panel *ngIf="!this.inactiveEc && !this.futureEc">
                    <mat-expansion-panel-header>
                        <mat-panel-description fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-bolt"></app-icon>
                            <span>{{ 'Energy sharing'|i18n }}</span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ng-container
                            *ngTemplateOutlet="sharedEnergyChart;">
                    </ng-container>
                    <ng-container
                            *ngTemplateOutlet="incentiveChart">
                    </ng-container>
                    <ng-container
                            *ngTemplateOutlet="energyRatioChart">
                    </ng-container>
                </mat-expansion-panel>
                <!--                <div fxLayoutAlign="end center">
                                    <button *ngIf="response" app-ghost-button (click)="exportEconomicsToExcel()" [disabled]="templateIsDownloading">
                                        <app-icon name="fal-file-excel"></app-icon>
                                        {{'Export to Excel'|i18n}}
                                    </button>
                                </div>-->
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #enterGseData let-data let-close="close">
    <div class="gse-data app-dialog-background">
        <app-ec-gse-data [date]="singleDate"
                         (values)="data.values = $event"
                         (valid)="data.valid = $event">
        </app-ec-gse-data>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24" fxLayoutGap="20px">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            <app-icon name="fal-check-circle"></app-icon>
            {{ 'Save'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #dialogSelectMonth let-data let-close="close">
    <div class="gse-data app-dialog-background">
        <app-ec-select-date [summaryConsolidations]="summaryResponse"
                            [content]="CONTENT_DIALOG.GSE"
                            [minDate]="getMomentFromMs(billingPeriodCfg.pastDate, timeZone)"
                            [maxDate]="getPastMonth(timeZone)"
                            (values)="data.values = $event"
                            (valid)="data.valid = $event">
        </app-ec-select-date>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24" fxLayoutGap="20px">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Not now'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            {{ 'Upload month file'|i18n }}
            <app-icon class="ml-10" name="fal-arrow-right"></app-icon>
        </button>
    </div>
</ng-template>

<ng-template #costsSetup let-data let-close="close">
    <div class="costs app-dialog-background">
        <app-ec-costs [response]="response"
                      [totalPods]="totalPods"
                      (values)="data.values = $event"
                      (valid)="data.valid = $event">
        </app-ec-costs>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24" fxLayoutGap="20px">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            {{ 'Confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #sharedEnergyChart let-data="data">
    <div *ngIf="energiesChartOptions" fxLayout="column" class="mt-16">
        <div fxLayout="column" fxLayoutAlign="start stretch" class="eco-chart">
            <div fxLayout="row" fxLayoutAlign="start" class="quantity-name" fxLayoutGap="20px">
                <span class="text-primary"> {{ 'Shared energy'|i18n }} </span>
                <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
                    <mat-checkbox app-checkbox
                                  [checked]="sharedEnergyEstimatedData"
                                  (change)="updateEnergyEstimated($event.checked)">
                        <span class="txt-h-12-4"> {{ 'Estimated data'|i18n }}</span>
                    </mat-checkbox>
                    <mat-checkbox app-checkbox
                                  [checked]="sharedEnergyConsolidatedData"
                                  [disabled]="!consolidationsAvailable(response)"
                                  (change)="updateEnergyConsolidated($event.checked)">
                        <span class="txt-h-12-4"> {{ 'Consolidated data'|i18n }} </span>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="!energiesChartOptions.series" fxLayout="row" fxLayoutAlign="center">
                <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                {{ 'No data'|i18n }}
            </div>
            <ng-container *ngIf="energiesChartOptions.series">
                <div class="shared-energy">
                    <apx-chart
                            [series]="energiesChartOptions.series"
                            [chart]="energiesChartOptions.chart"
                            [stroke]="energiesChartOptions.stroke"
                            [dataLabels]="energiesChartOptions.dataLabels"
                            [plotOptions]="energiesChartOptions.plotOptions"
                            [xaxis]="energiesChartOptions.xaxis"
                            [colors]="energiesChartOptions.colors"
                            [fill]="energiesChartOptions.fill"
                            [yaxis]="energiesChartOptions.yaxis"
                            [legend]="energiesChartOptions.legend"></apx-chart>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>


<ng-template #incentiveChart let-data="data">
    <div *ngIf="incentivesChartOptions" fxLayout="column" class="mt-16">
        <div fxLayout="column" fxLayoutAlign="start stretch" class="eco-chart">
            <div fxLayout="row" fxLayoutAlign="start" class="quantity-name" fxLayoutGap="20px">
                <span class="text-primary"> {{ 'Total incentive'|i18n }} </span>
                <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
                    <mat-checkbox app-checkbox
                                  [checked]="incentiveEstimatedData"
                                  (change)="updateIncentiveEstimated($event.checked)"
                    >
                        <span class="txt-h-12-4"> {{ 'Estimated data'|i18n }}</span>
                    </mat-checkbox>
                    <mat-checkbox app-checkbox
                                  [checked]="incentiveConsolidatedData"
                                  [disabled]="!consolidationsAvailable(response)"
                                  (change)="updateIncentiveConsolidated($event.checked)">
                        <span class="txt-h-12-4"> {{ 'Consolidated data'|i18n }} </span>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="!incentivesChartOptions.series" fxLayout="row" fxLayoutAlign="center">
                <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                {{ 'No data'|i18n }}
            </div>
            <ng-container *ngIf="incentivesChartOptions.series">
                <div class="shared-energy">
                    <apx-chart
                            [series]="incentivesChartOptions.series"
                            [chart]="incentivesChartOptions.chart"
                            [stroke]="incentivesChartOptions.stroke"
                            [dataLabels]="incentivesChartOptions.dataLabels"
                            [plotOptions]="incentivesChartOptions.plotOptions"
                            [xaxis]="incentivesChartOptions.xaxis"
                            [colors]="incentivesChartOptions.colors"
                            [fill]="incentivesChartOptions.fill"
                            [yaxis]="incentivesChartOptions.yaxis"
                            [legend]="incentivesChartOptions.legend"></apx-chart>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>


<ng-template #energyRatioChart let-data="data">
    <div *ngIf="energyRatioChartOptions" fxLayout="column" class="mt-16">
        <div fxLayout="column" fxLayoutAlign="start stretch" class="eco-chart">
            <div fxLayout="row" fxLayoutAlign="start" class="quantity-name" fxLayoutGap="20px">
                <span class="text-primary"> {{ 'Shared energy ratio'|i18n }} </span>
                <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
                    <mat-checkbox app-checkbox
                                  [checked]="energyRatioEstimatedData"
                                  (change)="updateEnergyRatioEstimated($event.checked)"
                    >
                        <span class="txt-h-12-4"> {{ 'Estimated data'|i18n }}</span>
                    </mat-checkbox>
                    <mat-checkbox app-checkbox
                                  [checked]="energyRatioConsolidatedData"
                                  [disabled]="!consolidationsAvailable(response)"
                                  (change)="updateEnergyRatioConsolidated($event.checked)">
                        <span class="txt-h-12-4"> {{ 'Consolidated data'|i18n }} </span>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="!energyRatioChartOptions.series" fxLayout="row" fxLayoutAlign="center">
                <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                {{ 'No data'|i18n }}
            </div>
            <ng-container *ngIf="energyRatioChartOptions.series">
                <div class="shared-energy">
                    <apx-chart
                            [series]="energyRatioChartOptions.series"
                            [chart]="energyRatioChartOptions.chart"
                            [stroke]="energyRatioChartOptions.stroke"
                            [dataLabels]="energyRatioChartOptions.dataLabels"
                            [plotOptions]="energyRatioChartOptions.plotOptions"
                            [xaxis]="energyRatioChartOptions.xaxis"
                            [colors]="energyRatioChartOptions.colors"
                            [fill]="energyRatioChartOptions.fill"
                            [yaxis]="energyRatioChartOptions.yaxis"
                            [legend]="energyRatioChartOptions.legend"></apx-chart>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>


<ng-template #loadingEconomics>
    <div fxLayout="column" fxLayoutAlign="space-around center">
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
            <mat-spinner app-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{ 'Loading'|i18n }}...</span>
        </div>
        <div *ngIf="showComputationWarning" fxLayout="row" fxLayoutAlign="center center"
             fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'We are recalculating the economics data due to an updated configuration parameter.'|i18n }}</div>
        </div>
    </div>
</ng-template>


<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<ng-template #ecWaitingForApproval>
    <div fxLayout="column" class="p-30" fxLayoutAlign="center center">
        <div class="txt-h-24-7">{{ 'Community waiting for activation'|i18n }}</div>
        <app-icon icon-color-h name="fal-clock" fxFlex="60" class="clock-icon mt-30 mb-30"></app-icon>
        <ng-container *ngIf="inactiveEc">
            <div class="txt-s-16-4">{{ 'This community has no activation date yet.'|i18n }}</div>
            <div class="txt-s-16-4">{{ 'As soon as the community is activated, you will see economic and energy data here.'|i18n }}</div>
        </ng-container>
        <ng-container *ngIf="!inactiveEc">
            <div class="txt-s-16-4">{{ 'This community will be activated by {0}.'|i18n:(billingPeriodCfg.pastDate|i18nDate) }}</div>
            <div class="txt-s-16-4">{{ 'Economic data will be available from that day.'|i18n }}</div>
        </ng-container>
        <div mat-dialog-actions class="dialog-actions mt-30">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #membershipDialog let-data let-close="close">
    <div class="app-dialog-background">
        <app-membership-fee
                [date]="singleDate"
                [currentMembershipFee]="response.membership_fee"
                (membershipFeeEmitter)="data.membershipFee = $event"
                (valid)="data.valid = $event">
        </app-membership-fee>
    </div>
    <div mat-dialog-actions class="dialog-actions" fxLayoutAlign="center" fxLayoutGap="20px" class="mt-20 mb-20">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-ghost-button [mat-dialog-close]="true" (click)="close(null)">
            {{ 'Reset'|i18n }}
        </button>
        <button app-primary-button [mat-dialog-close]="true" [disabled]="!data.valid"
                (click)="close(data.membershipFee)">
            {{ 'Confirm'|i18n }}
        </button>
    </div>
</ng-template>


<ng-template #chooseStrategy let-data let-close="close">
    <app-strategy
            [availableStrategies]="availableStrategies"
            (selected)="close(data.values = $event)">

    </app-strategy>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>
